// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-nav {
  background: white;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.category-nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.category-nav-content {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 0;
}

.nav-item {
  display: inline-flex; /* 改为inline-flex以适应内容宽度 */
  align-items: center;
  justify-content: center;
  padding: 0 20px; /* 保持固定的左右padding */
  border: 1px solid var(--color-primary) !important;
  background: var(--color-bg-white) !important;
  border-radius: 9999px !important;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-primary) !important;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap; /* 防止文字换行 */
  height: 36px;
  min-width: auto; /* 移除最小宽度限制 */
  width: auto; /* 宽度自适应内容 */
  box-sizing: border-box; /* 确保padding计算正确 */
}

.nav-item:hover {
  background: var(--color-primary) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.nav-item-active {
  background: var(--color-primary) !important;
  color: white !important;
  box-shadow: var(--shadow-md);
}

.nav-item-active:hover {
  background: var(--color-primary) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.nav-text {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap; /* 防止文字换行 */
  overflow: visible; /* 确保文字完全显示 */
  text-overflow: clip; /* 不使用省略号 */
}

/* 在Mobile端隐藏CategoryNav，PAD端显示但使用水平滚动 */
@media (max-width: 768px) and (min-width: 481px) {
  .category-nav {
    position: sticky;
    top: 56px; /* Header高度 */
    z-index: 999;
  }

  .category-nav-container {
    padding: 0 16px;
    position: relative;
  }

  .category-nav-content {
    flex-wrap: nowrap; /* 不换行，单行显示 */
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    padding: 16px 0;
    gap: 8px;
  }

  /* 隐藏滚动条 */
  .category-nav-content::-webkit-scrollbar {
    display: none;
  }

  .nav-item {
    flex-shrink: 0;
    margin-right: 0; /* 使用gap代替margin */
  }

  .nav-item:first-child {
    margin-left: 8px;
  }

  .nav-item:last-child {
    margin-right: 8px;
  }

  /* 添加渐变遮罩效果，提示可以滚动 */
  .category-nav-container::before,
  .category-nav-container::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 20px;
    pointer-events: none;
    z-index: 1;
  }

  .category-nav-container::before {
    left: 16px;
    background: linear-gradient(to right, white, transparent);
  }

  .category-nav-container::after {
    right: 16px;
    background: linear-gradient(to left, white, transparent);
  }
}

/* 在Mobile端隐藏CategoryNav */
@media (max-width: 480px) {
  .category-nav {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CategoryNav/CategoryNav.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB,EAAE,yBAAyB;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,mBAAmB;EACpC,iDAAiD;EACjD,4CAA4C;EAC5C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB,EAAE,WAAW;EAChC,YAAY;EACZ,eAAe,EAAE,aAAa;EAC9B,WAAW,EAAE,YAAY;EACzB,sBAAsB,EAAE,kBAAkB;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,WAAW;EAChC,iBAAiB,EAAE,aAAa;EAChC,mBAAmB,EAAE,WAAW;AAClC;;AAEA,wCAAwC;AACxC;EACE;IACE,gBAAgB;IAChB,SAAS,EAAE,aAAa;IACxB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB,EAAE,aAAa;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,gBAAgB;IAC1C,eAAe;IACf,QAAQ;EACV;;EAEA,UAAU;EACV;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;;IAEE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yDAAyD;EAC3D;;EAEA;IACE,WAAW;IACX,wDAAwD;EAC1D;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".category-nav {\n  background: white;\n  border-bottom: 1px solid #e8e8e8;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.category-nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.category-nav-content {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.nav-item {\n  display: inline-flex; /* 改为inline-flex以适应内容宽度 */\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px; /* 保持固定的左右padding */\n  border: 1px solid var(--color-primary) !important;\n  background: var(--color-bg-white) !important;\n  border-radius: 9999px !important;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-primary) !important;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  white-space: nowrap; /* 防止文字换行 */\n  height: 36px;\n  min-width: auto; /* 移除最小宽度限制 */\n  width: auto; /* 宽度自适应内容 */\n  box-sizing: border-box; /* 确保padding计算正确 */\n}\n\n.nav-item:hover {\n  background: var(--color-primary) !important;\n  color: white !important;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.nav-item-active {\n  background: var(--color-primary) !important;\n  color: white !important;\n  box-shadow: var(--shadow-md);\n}\n\n.nav-item-active:hover {\n  background: var(--color-primary) !important;\n  color: white !important;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.nav-text {\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap; /* 防止文字换行 */\n  overflow: visible; /* 确保文字完全显示 */\n  text-overflow: clip; /* 不使用省略号 */\n}\n\n/* 在Mobile端隐藏CategoryNav，PAD端显示但使用水平滚动 */\n@media (max-width: 768px) and (min-width: 481px) {\n  .category-nav {\n    position: sticky;\n    top: 56px; /* Header高度 */\n    z-index: 999;\n  }\n\n  .category-nav-container {\n    padding: 0 16px;\n    position: relative;\n  }\n\n  .category-nav-content {\n    flex-wrap: nowrap; /* 不换行，单行显示 */\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    padding: 16px 0;\n    gap: 8px;\n  }\n\n  /* 隐藏滚动条 */\n  .category-nav-content::-webkit-scrollbar {\n    display: none;\n  }\n\n  .nav-item {\n    flex-shrink: 0;\n    margin-right: 0; /* 使用gap代替margin */\n  }\n\n  .nav-item:first-child {\n    margin-left: 8px;\n  }\n\n  .nav-item:last-child {\n    margin-right: 8px;\n  }\n\n  /* 添加渐变遮罩效果，提示可以滚动 */\n  .category-nav-container::before,\n  .category-nav-container::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20px;\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  .category-nav-container::before {\n    left: 16px;\n    background: linear-gradient(to right, white, transparent);\n  }\n\n  .category-nav-container::after {\n    right: 16px;\n    background: linear-gradient(to left, white, transparent);\n  }\n}\n\n/* 在Mobile端隐藏CategoryNav */\n@media (max-width: 480px) {\n  .category-nav {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
